import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { DomainDetBus } from '../models/DomainDetBus';
import { BillingCodeBus } from '../models/BillingCodeBus';

@Injectable()
export class DomainService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Domain/";
    }

    GetDomainData(typeId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDomainData/" + typeId;
        return super.get(url_call);
    }
    saveDomainData(typeId: number, busObj: DomainDetBus) {
        let url_call: string = this.baseUrl + "SaveDomainData/" ;
        return this.put(url_call, typeId, busObj);
    }
    getBillingCodeById(billingCodeId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetBillingCodeById/" + billingCodeId;
        return this.get(url_call);
    }
    getAccountsDomain(): Observable<any> {
        let url_call: string = this.baseUrl + "GetAccountsDomain/";
        return this.get(url_call);
    }

    saveBillingCode(busObj: BillingCodeBus) {
        let url_call: string = this.baseUrl + "SaveBillingCode/";
        return this.put(url_call,"",busObj);
    }

    getAllBillingCodes(): Observable<any> {
        let url_call: string = this.baseUrl + "GetAllBillingCodes/";
        return this.get(url_call);
    }

}
